/**
 *
 * @param {string} url
 * @returns
 */
export const isWoxo = (url) =>
  url.includes(`${process.env.WIDGETS_HOST}`) ||
  url.startsWith("http://127.0.0.1");
